import React, { useEffect } from 'react';
import Navbar from './Components/Navbar'
import FirstSlide from './Pages/FirstSlide'
import Secondslide from './Pages/Secondslide';
import Thirdslide from './Pages/Thirdslide';
import OurClub from './Pages/OurClub';
import NewArrival from './Pages/NewArrival';
import ChooseUS from './Pages/ChooseUS';
import Testimonial from './Pages/Testimonial';
import Slider from './Pages/Slider'
import Footer from './Components/Footer';
// import MainpageBanner from './Pages/MainpageBanner';
import CustomizeARCHITECTProjectForm from './Pages/customiseYourProjectslide.js';
import Areyouanartistslide from './Pages/areyouanartistslide.js';
import CustomizeProjectForm from './Pages/Customiseprojectslide.js';
import OurJourneySlide from './Pages/OurJourney.js';

const Index = () => {
  // Clear all category-specific lastViewedImageId keys from sessionStorage when home page loads
  useEffect(() => {
    const storageKeys = [
      'lastViewedImageIdWallcoveringdecorative',
      'lastViewedImageIdWallcoveringabstract',
      'lastViewedImageIdWallcoveringCorporate',
      'lastViewedImageIdWallcoveringkids',
      'lastViewedImageIdWallcoveringminimalpattern',
      'lastViewedImageIdWallcoveringviewall',
      'lastViewedImageIdArtprintsabstract',
      'lastViewedImageIdArtprintsDecorative',
      'lastViewedImageIdArtprintsExclusive',
      'lastViewedImageIdArtprintsLandscape',
      'lastViewedImageIdArtprintsViewall',
      'lastViewedImageIdExclusivehandpainting'
    ];

    let clearedCount = 0;
    storageKeys.forEach(key => {
      if (sessionStorage.getItem(key)) {
        sessionStorage.removeItem(key);
        clearedCount++;
      }
    });

    if (clearedCount > 0) {
      console.log(`[Index] Home page loaded - cleared ${clearedCount} lastViewedImageId keys from sessionStorage`);
    }
  }, []);

  return (
    <div>
      <Navbar />
      <FirstSlide />
      {/* <MainpageBanner /> */}
      <Thirdslide />
      <Secondslide />
      <OurClub />
      <NewArrival />
      <ChooseUS />
      <Slider />
      <CustomizeProjectForm />
      <OurJourneySlide />
      <CustomizeARCHITECTProjectForm />
      <Testimonial />
      <Areyouanartistslide />
      {/* <br /> */}
      <Footer />
      {/* Scroll Button */}

    </div>
  );
};

export default Index;